import { TableRow, TableCell } from '@mui/material'
import { useSelector } from 'react-redux'
import { IProject, IProjectAndActivity } from '../../interface/IProjects'
import { format } from 'date-fns'
import { formatTimeAsLocal } from '../../utils/functions/timeUtils'
import React from 'react'

const OnCallShiftsTable = ({ line }: { line: any }) => {
    const projects: IProject[] = useSelector((state: any) => state.projects?.value) || []
    const projectActivity = line.mserp_indirectactivitycategoryid !== 'SYSTEM'
    let projectId = projectActivity ? line.mserp_projectid : line.mserp_timeandattendancejobid
    let projectName = projects.find((item) => item.mserp_projectid === projectId)?.mserp_projectname
    let activityId = line.mserp_timeandattendancejobid
    let activityName = projectActivity ? projects.find((item) => item.mserp_projectid === line.mserp_projectid)?.activities?.find((act: IProjectAndActivity) => act.mserp_jobid === line.mserp_timeandattendancejobid)?.mserp_description : projectName
    const amountHours = (line.mserp_calculatedtimeseconds || 0) / 3600.0
    const onSE = line.mserp_oncalltimeandattendancejobid == 'SE'
    let from
    let to

    if (onSE) {
        from = formatTimeAsLocal(line.mserp_startdatetime, line.mserp_timeprofiledate)
        to = formatTimeAsLocal(line.mserp_stopdatetime, line.mserp_timeprofiledate)
    }

    if (!onSE) {
        projectId = undefined
        projectName = undefined
        activityId = undefined
        activityName = undefined
    }

    return (
        <TableRow>
            <TableCell sx={{ paddingY: 0.5, paddingX: 0 }}>{format(line.mserp_timeprofiledate, 'dd.MM.yyyy') || '—'}</TableCell>
            <TableCell sx={{ paddingY: 0.5, paddingLeft: 0.5 }}>{line.mserp_oncalltimeandattendancejobid || '—'}</TableCell>
            <TableCell sx={{ paddingY: 0.5, paddingX: 0 }}>
                {projectId || '—'} {projectName ? `- ${projectName}` : ''}
            </TableCell>
            <TableCell sx={{ paddingY: 0.5, paddingX: 0 }}>
                {activityId || '—'} {activityName ? `- ${activityName}` : ''}
            </TableCell>
            <TableCell sx={{ paddingY: 0.5, paddingX: 0 }} align="right">
                {amountHours === 0 ? '—' : amountHours.toFixed(2)}
            </TableCell>
            {onSE && (
                <>
                    <TableCell sx={{ paddingY: 0.5, paddingRight: 0.5 }} align="right">
                        {from}
                    </TableCell>
                    <TableCell sx={{ paddingY: 0.5, paddingRight: 0 }} align="right">
                        {to}
                    </TableCell>
                </>
            )}
        </TableRow>
    )
}

export default OnCallShiftsTable
